import { Component, Input, OnInit } from '@angular/core';
import { ProductUnit } from '@core/services/data.service';

@Component({
  selector: 'cny-per-unit',
  templateUrl: './cny-per-unit.component.html',
  styleUrls: ['./cny-per-unit.component.scss']
})
export class CnyPerUnitComponent implements OnInit {

  @Input()
  public type: ProductUnit = ProductUnit.Unknown;

  public get name(): string {
    switch (this.type) {
      case ProductUnit.Meter: return 'm';
      case ProductUnit.Kilogram: return 'kg';
      default: return 'đv';
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
